import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    name: 'index',
    redirect: '/home',
    component: () => import('@/views/index')
  }, {
    path: '/home',
    name: 'About',
    component: () => import('@/views/index')
  }, {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about')
  }, {
    path: '/qualification',
    name: 'Qualification',
    component: () => import('@/views/qualification')
  }, {
    path: '/product',
    name: 'Product',
    component: () => import('@/views/product')
  }, {
    path: '/product/search',
    name: 'ProductSearch',
    component: () => import('@/views/productSearch')
  }, {
    path: '/product/detail',
    component: () => import('@/views/productDetail'),
    name: 'ProductDetail'
  }, {
    path: '/product/detail/yly',
    component: () => import('@/views/product_yly'),
    name: 'ProductDetail'
  }, {
    path: '/product/detail/yyj',
    component: () => import('@/views/product_yyj'),
    name: 'ProductDetail'
  }, {
    path: '/product/detail/yfl',
    component: () => import('@/views/product_yfl'),
    name: 'ProductDetail'
  }, {
    path: '/cases',
    name: 'Cases',
    component: () => import('@/views/cases'),
    hidden: true
  }, {
    path: '/cases/detail',
    name: 'CasesDetail',
    component: () => import('@/views/casesDetail'),
    hidden: true
  }, {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news'),
    hidden: true
  }, {
    path: '/news/detail',
    name: 'NewsDetail',
    component: () => import('@/views/newsDetail'),
    hidden: true
  }, {
    path: '/service',
    name: 'Service',
    component: () => import('@/views/service'),
    hidden: true
  }, {
    path: '/service/detail/service1',
    component: () => import('@/views/service1'),
    name: 'ServiceDetail'
  }, {
    path: '/service/detail/service2',
    component: () => import('@/views/service2'),
    name: 'ServiceDetail'
  }, {
    path: '/service/detail/service3',
    component: () => import('@/views/service3'),
    name: 'ServiceDetail'
  }, {
    path: '/service/detail/service4',
    component: () => import('@/views/service4'),
    name: 'ServiceDetail'
  }, {
    path: '/service/detail/service5',
    component: () => import('@/views/service5'),
    name: 'ServiceDetail'
  }, {
    path: '/service/detail',
    name: 'ServiceDetail',
    component: () => import('@/views/serviceDetail'),
    hidden: true
  }, {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/contact'),
    hidden: true
  }, {
    path: '/joinIn',
    name: 'JoinIn',
    component: () => import('@/views/joinIn'),
    hidden: true
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js